import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import {
  PRESS_HOVER,
  PRESS_TAP,
  PRESS_TRANSITION,
} from "../../utils/motionInteractions";

const CreateEventBanner = ({ onClick, disabled = false, mode = "create", badgeCount = 0 }) => {
  const { t } = useTranslation("events");
  const isPanel = mode === "panel";
  const isHostCreate = mode === "host-create";
  const isConceptCreate = mode === "concept";
  const title = t(isHostCreate
    ? "catalog_sections.create_event_or_concept"
    : isPanel ? "catalog_sections.open_panel"
    : isConceptCreate ? "create_event_banner.concept_title"
    : "create_event_banner.title");
  const subtitle = isHostCreate ? "" : t(isPanel
    ? "catalog_sections.manage_events"
    : isConceptCreate ? "create_event_banner.concept_subtitle"
    : "create_event_banner.subtitle");

  return (
    <motion.button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={isPanel || isHostCreate ? title : t(isConceptCreate
        ? "create_event_banner.concept_link_aria"
        : "create_event_banner.link_aria")}
      whileHover={disabled ? undefined : PRESS_HOVER}
      whileTap={disabled ? undefined : PRESS_TAP}
      transition={PRESS_TRANSITION}
      className="vg-create-event-banner-flow relative h-[60px] w-full overflow-hidden rounded-2xl border border-white/85 text-left font-semibold text-white shadow-[0_10px_24px_rgba(19,60,170,0.22),inset_0_1px_0_rgba(255,255,255,0.28)] disabled:pointer-events-none disabled:opacity-60"
    >
      <span
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.18)_0%,rgba(255,255,255,0.04)_50%,rgba(6,23,82,0.12)_100%)]"
        aria-hidden="true"
      />
      <div className="relative flex h-full items-center justify-between px-4">
        <div className="flex min-w-0 flex-col justify-center pr-12 leading-tight">
          <span className="text-white text-lg font-semibold -mt-[3px]">
            {title}
            {isPanel && Number(badgeCount) > 0 ? (
              <span className="ml-2 inline-flex min-w-[20px] items-center justify-center rounded-full bg-white px-1.5 align-middle text-xs font-bold text-[#0A64FF]">
                {badgeCount > 99 ? "99+" : badgeCount}
              </span>
            ) : null}
          </span>
          {subtitle ? (
            <span className="text-white text-sm font-medium mb-[2px]">
              {subtitle}
            </span>
          ) : null}
        </div>
        <img
          src="/assets/events/right_arrow.svg"
          alt={t("create_event_banner.arrow_alt")}
          className="w-[28px] h-[20px] absolute right-[20px] top-1/2 -translate-y-1/2"
        />
      </div>
    </motion.button>
  );
};

export default CreateEventBanner;
